// extracted by mini-css-extract-plugin
export var active = "_9x-d";
export var blink = "_9x-e";
export var container = "_9x-5";
export var controls = "_9x-0";
export var controlsRight = "_9x-1";
export var fakeCursor = "_9x-c";
export var hidden = "_9x-b";
export var quillContainerSmall = "_9x-7";
export var quillEditor = "_9x-6";
export var quillEditorSmall = "_9x-8";
export var quillFormatButtons = "_9x-a";
export var quillToolbar = "_9x-9";
export var removePadding = "_9x-2";
export var state = "_9x-3";
export var stateTitle = "_9x-4";